// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .payment-setting[data-v-06d6349e] {\n  width: 500px;\n  height: 300px;\n  border-radius: 5px;\n  margin: 10px auto;\n  background-color: #d1d1d1;\n  text-align: center;\n}\n.el-radio[data-v-06d6349e] {\n  position: absolute;\n  left: 0;\n  line-height: 40px;\n}\n.el-button--small[data-v-06d6349e] {\n  position: absolute;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
